/**
 * versionCheck — Eski önbelleğe sabitlenmiş istemcileri kendine onartır.
 *
 * Build sırasında bundle'a gömülen __BUILD_ID__, sunucudaki /version.json
 * (no-store, SW precache dışı) ile karşılaştırılır. Uyuşmazlıkta service
 * worker kayıtları silinir, tüm Cache Storage temizlenir ve sayfa BİR kez
 * yenilenir. Sürüm başına tek deneme (localStorage guard) — döngü olmaz.
 *
 * Kontroller: açılışta, sekme öne gelince ve 5 dakikada bir.
 */

const CHECK_INTERVAL_MS = 5 * 60 * 1000;
const HEAL_KEY = 'fc-version-healed';

async function nukeAndReload(serverId) {
  try {
    localStorage.setItem(HEAL_KEY, serverId);
  } catch { /* private mode */ }

  const tasks = [];
  if (navigator.serviceWorker?.getRegistrations) {
    tasks.push(
      navigator.serviceWorker.getRegistrations()
        .then((regs) => Promise.all(regs.map((r) => r.unregister())))
    );
  }
  if (window.caches?.keys) {
    tasks.push(
      caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
    );
  }
  await Promise.allSettled(tasks);
  window.location.reload();
}

async function checkVersion() {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return;
    const { id: serverId } = await res.json();
    if (!serverId || serverId === __BUILD_ID__) return;

    // Döngü koruması: aynı sürüm için en fazla 10 dakikada bir onarma.
    // (Önceki kural "sürüm başına tek deneme" idi — iOS-PWA ilk denemede
    // eski paketi tutunca cihaz sonsuza kadar eski sürümde kalıyordu.)
    let healed = null;
    try { healed = localStorage.getItem(HEAL_KEY); } catch { /* noop */ }
    if (healed) {
      const [hid, ts] = healed.split('|');
      if (hid === serverId && Date.now() - Number(ts || 0) < 10 * 60 * 1000) return;
    }

    await nukeAndReload(`${serverId}|${Date.now()}`);
  } catch { /* offline vb. — sessiz geç */ }
}

export function startVersionCheck() {
  checkVersion();
  setInterval(checkVersion, CHECK_INTERVAL_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkVersion();
  });
}
